import React, { useState, useEffect, useRef } from 'react'
import { Spinner } from "@blueprintjs/core";
import { getHostname } from "../../../utility/hostname";
import { formatVideoSeconds } from "../../../utility/formatters";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import "./ItemThumbnail.scss";
import useAtomWithUrlParam from '../../../hooks/useAtomWithUrlParam';
import { versionAtom, versionAtomDefault } from '../../../atoms';

export default function ItemThumbnail({ item }) {
    const [version] = useAtomWithUrlParam(versionAtom, versionAtomDefault);
    const [placeholderLoaded, setPlaceholderLoaded] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [videoSrc, setVideoSrc] = useState("");
    // const [thumbnailSrc, setThumbnailSrc] = useState("");
    const mounted = useRef(false);  // Avoid trying to update state in useEffect() if component is unmounted

    // Load resources that require api keys on mount
    useEffect(() => {
        mounted.current = true;
        const auth_headers = { 'x-api-key': localStorage.getItem('api-key'), 'mode': 'cors' };

        // Load video src with api key
        const video_summary_url = `${getHostname()}/summary/${version}/${item.video_uid}`;
        fetch(video_summary_url, { headers: auth_headers })
            .then(res => res.blob())
            .then(blob => mounted.current && setVideoSrc(URL.createObjectURL(blob)));

        // // Load thumbnail src with api key
        // if (!!item.timestamps) {
        //     const thumbnail_url = `${getHostname()}/thumbnail/${version}/${item.video_uid}?frame=${item.timestamps[0] * 30.0}`;
        //     fetch(thumbnail_url, { headers: auth_headers })
        //         .then(res => res.blob())
        //         .then(blob => setThumbnailSrc(URL.createObjectURL(blob)));
        // }
        return () => {
            mounted.current = false;
        }

    }, [item.timestamps]);


    // Load Order: Skeleton -> Placeholder -> Thumbnail
    const center_spinner = (
        <div style={{ zIndex: 2, position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)' }}>
            <Spinner />
        </div>
    )

    const video_summary = <video
        className="item-thumbnail-summary"
        src={videoSrc}
        onMouseEnter={event => event.target.play()}
        onMouseLeave={event => event.target.pause()}
        onFocus={event => event.target.play()}
        onBlur={event => event.target.pause()}
        onLoad={() => setLoaded(true)}
        muted>
        <track kind="captions" srcLang="en" />
    </video>

    const placeholder = (
        <div style={{ display: loaded ? 'none' : 'inherit' }}>
            {!!item.timestamps && center_spinner}
            <img
                role="presentation"
                onError={(e) => {
                    e.target.onerror = null;
                }}
                src={`${getHostname()}/thumbnail/${version}/${item.video_uid}`}
                alt="Thumbnail"
                style={{ zIndex: 1, position: 'absolute', width: '100%', height: '100%', 'objectFit': 'cover', borderRadius: '3px', opacity: !!item.timestamps ? 0.6 : 1.0 }}
                onLoad={() => setPlaceholderLoaded(true)}
            />
        </div>
    );

    const timestampped_thumbnail = !!item.timestamps && (
        <img
            role="presentation"
            src={`${getHostname()}/thumbnail/${version}/${item.video_uid}?frame=${item.timestamps[0] * 30.0}`}
            alt="Thumbnail"
            style={{ zIndex: 3, position: 'absolute', width: '100%', height: '100%', 'objectFit': 'cover', borderRadius: '3px' }}
            onLoad={() => setLoaded(true)}
        />
    )

    if (!!item.timestamps) {
        return <div style={{ position: 'relative', width: item._img ? "100%" : "1px", height: "25vh", minHeight: '200px', overflow: 'hidden' }}>
            {/* Load Order: Skeleton */}
            {!placeholderLoaded && <Skeleton style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 2, opacity: 1 }} />}
            {/* Load Order: Placeholder */}
            {!loaded && placeholder}

            {/* Load Order: Timestampped Thumbnail */}
            {placeholderLoaded && timestampped_thumbnail}

            {/* Load Order: Video Summary */}
            {loaded && <div class="visible-on-hover">{video_summary}</div>}

            {/* Always show timestamp overlay*/}
            <span style={{ position: 'absolute', right: 3, bottom: 5, zIndex: 4, color: 'white', fontSize: '0.8rem' }}>
                start: {formatVideoSeconds(item.timestamps[0])}
                {item.timestamps.length > 1 ? ` + ${item.timestamps.length - 1}` : ''}
            </span>
        </div>
    }
    return <div style={{ position: 'relative', width: item._img ? "100%" : "1px", height: "25vh", minHeight: '200px', overflow: 'hidden' }}>
        {/* Load Order: Skeleton */}
        {!loaded && <Skeleton style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 2, opacity: 1 }} />}

        {/* Load Order: Placeholder */}
        {/* {!loaded && placeholder} */}

        {/* Load Order: Video Summary */}
        {video_summary}
    </div>;
}
